import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastData, ToastExampleComponent } from '../component/toast-example/toast-example.component';
import { ToastService } from '@pearsonvue/topaz-angular-ui';
import { Router } from '@angular/router';
import { LogoutModalComponent } from '../component/logout-modal/logout-modal.component';
import { MatDialog } from '@angular/material/dialog';
import Utils from '../utils/utils';
import { AuthService } from '../auth/auth.service';

export class HeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modified = req.clone({
      withCredentials: true,
    });
    return next.handle(modified);
  }
}

export class ErrorInterceptor implements HttpInterceptor {
  public logOutDialogConfig: any = {};
  public isEmail: any 
  public toastService = inject(ToastService<ToastData>);
  public router = inject(Router);
  public dialogModel = inject(MatDialog);
  public util = inject(Utils);
  public isGlobalbar: boolean = false;
  private _auth: AuthService = inject(AuthService);
  
  intercept(req : HttpRequest<unknown>, next:HttpHandler): Observable<HttpEvent<unknown>>{
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const reqMethod = req.method;
          if(reqMethod != "GET" && event.status == 200){
            // Toaster Configuration
            this.toastService.initialize({ enableAutoDismiss: true, autoDismissDelay: 3500 })
            // console.log('Request:', req);
            // console.log('Response Status:', event);
            const msg = event.body.message[0];
            msg!=undefined?this.toastService.open(ToastExampleComponent, { toastType: "success",  name: msg}):'';
          }
        }
      }),
      catchError(error => {
        this.toastService.initialize({ enableAutoDismiss: true, autoDismissDelay: 3500 })
        if (error.status === 401 && !this.router.url.startsWith('/find-your-fee')) {
           //alert('Your session is currently inactive.');
          
          //this.router.navigate(['/authcheck']);
          this._auth.changeMessage('default message');
           this.isGlobalbar = false;
           if (this.router.url !== '/domain-error?source=user' && this.router.url !== '/domain-error?source=admin' && this.router.url !== '/error') {
          this.router.navigate(['/prelogin']);
           }
         
          
          //window.location.reload();
          

        } else if(error.status === 403){
          let msg = error.error.errors[0];
          
          //1 - session has been expired / User have been logged out
          //2 - not registed usr trieg to login
          //3 - saml error reponse

          this.logOutDialogConfig = {
            type: 'logout',
            forComponent: 'logout',
            value: msg,
            caseScenario: this.util.checkForSubstring(msg)
          }

          this.dialogModel.open(LogoutModalComponent, { data: this.logOutDialogConfig, disableClose: true });

        } else {
          if(error instanceof HttpErrorResponse){
            const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
            errMsg && errMsg.map((msg: string) => {
              msg &&  this.toastService.open(ToastExampleComponent, { toastType: "alert",  name: msg});
            });
          }else{
           this.toastService.open(ToastExampleComponent, { toastType: "alert",  name: 'some other Error occured'});
          }

        }
        return throwError(() => new Error(error.statusText))
      })
    )
  }
}